import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { BillingProvider } from "@/context/BillingContext";
import Layout from "@/components/Layout";
import AuthPage from "@/pages/AuthPage";
import ForgotPassword from "@/pages/ForgotPassword";
import ResetPassword from "@/pages/ResetPassword";
import Dashboard from "@/pages/Dashboard";
import TripDetail from "@/pages/TripDetail";
import Pricing from "@/pages/Pricing";
import { BillingSuccess, BillingCancel } from "@/pages/BillingResult";
import { Toaster } from "@/components/ui/sonner";
import InstallPWA from "@/components/InstallPWA";

function Protected({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="min-h-screen grid place-items-center text-stone-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return <Layout>{children}</Layout>;
}

function GuestOnly({ children }) {
  const { user, ready } = useAuth();
  if (!ready) return null;
  if (user) return <Navigate to="/" replace />;
  return children;
}

export default function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BillingProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<GuestOnly><AuthPage mode="login" /></GuestOnly>} />
              <Route path="/register" element={<GuestOnly><AuthPage mode="register" /></GuestOnly>} />
              <Route path="/forgot-password" element={<GuestOnly><ForgotPassword /></GuestOnly>} />
              <Route path="/reset-password" element={<GuestOnly><ResetPassword /></GuestOnly>} />
              <Route path="/" element={<Protected><Dashboard /></Protected>} />
              <Route path="/trips/:id" element={<Protected><TripDetail /></Protected>} />
              <Route path="/pricing" element={<Protected><Pricing /></Protected>} />
              <Route path="/billing/success" element={<Protected><BillingSuccess /></Protected>} />
              <Route path="/billing/cancel" element={<Protected><BillingCancel /></Protected>} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
          <Toaster richColors position="top-right" />
          <InstallPWA />
        </BillingProvider>
      </AuthProvider>
    </div>
  );
}
